import { Box} from '@mui/material';
import MobileFrame from './Styles';
import { BeOurAgent } from './beOurAgent/Index';
import { SellyouProperty } from './sellYourProperty/Index';
import { Message } from './message/Index';
import { List } from './list/Index';

export const MobileContainer = ({ urlParams, activeTab, history, preview, prevLoader }) => {
    const tabs = urlParams.get("tab")
    const ofrType = urlParams.get('offer_type');
    const prpTyp = urlParams.get('property_type');
    const handleButtonClick = (url, ofr) => {
        activeTab.set({...activeTab.data, url: url, offerType: ofr});
        if(url === "list"){
            if(ofrType === null){
                history.push(`/campaign/website?type=real-property&tab=list&offer_type=${ofr}&property_type=all`);
            }else{
                history.push(`/campaign/website?type=real-property&tab=${url}&offer_type=${ofr}&property_type=${urlParams.get("property_type")}`);
            }
        }else{
            history.push(`/campaign/website?type=real-property&tab=${url}`);
        }
    };
    const handlerView = (tId) => {
        history.push(`/campaign/website?type=real-property&tab=${urlParams.get('tab')}&offer_type=${urlParams.get('offer_type')}&property_type=${prpTyp}&view_id=${tId}`)
    }
    const PageType = () => {
        if (tabs === "list") {
            return <List prpTyp={prpTyp} urlParams={urlParams} preview={preview} prevLoader={prevLoader} history={history} handlerView={handlerView}/>
        } else if (tabs === 'be-our-agent') {
            return <BeOurAgent />
        } else if (tabs === 'sell-your-property') {
            return <SellyouProperty />
        } else if (tabs === 'message-us') {
            return <Message />
        } else {
            return <Box>404 NOT</Box>
        }
    }
    return (
        <Box width="100%" height="100%" style={{ display: 'flex', justifyContent: 'center' }}>
            <MobileFrame urlParams={urlParams} ofrType={ofrType} handleButtonClick={handleButtonClick} activeTab={activeTab} history={history} prevLoader={prevLoader} preview={preview} >
                {PageType()}
            </MobileFrame>
        </Box>
    );
};